function pLimit(concurrency) {
  var queue = [];
  var active = 0;
  var next = function next2() {
    if (active < concurrency && queue.length > 0) {
      active++;
      var fn = queue.shift();
      fn();
    }
  };
  return function(fn) {
    return new Promise(function(resolve, reject) {
      queue.push(function() {
        fn().then(resolve).catch(reject).finally(function() {
          active--;
          next();
        });
      });
      next();
    });
  };
}
export {
  pLimit
};
//# sourceMappingURL=pLimit.js.map
